(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
  , specValidator = require('./spec-validator')
const required = require('@clocklimited/validity-required')

module.exports = function () {

  return schemata(
    { _id:
      { type: String
      }
    , enabled:
      { type: Boolean
      , defaultValue: true
      }
    , name:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , description:
      { type: String
      }
    , capacity:
      { type: String
      }
    , website:
      { type: String
      }
    , thumbnail:
      { type: String
      }
    , tags:
      { type: String
      }
    , email:
      { type: String
      }
    , phone1:
      { type: String
      }
    , phone2:
      { type: String
      }
    , fax1:
      { type: String
      }
    , fax2:
      { type: String
      }
    , addressLine1:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , addressLine2:
      { type: String
      }
    , postcode:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , city:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , country:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , contacts:
      { type: Array
      }
    , specDocument:
      { type: Object
      , defaultValue: null
      , validators:
        { all: [ specValidator ]
        }
      }
    , dateCreated:
      { type: Date
      , defaultValue: function () { return new Date() }
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/venue/schema.js","/components/service/venue")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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